export const downloadBlob = (filename, blob) => {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);

    // Use special ms version if available to get it working on Edge.
    if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
        return;
    }

    if ('download' in HTMLAnchorElement.prototype) {
        const url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.type = blob.type;
        downloadLink.click();
        // remove the link after a timeout to prevent a crash on iOS 13 Safari
        window.setTimeout(() => {
            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(url);
        }, 1000);
    } else {
        // iOS 12 Safari, open a new page and set href to data-uri
        let popup = window.open('', '_blank');
        const reader = new FileReader();
        reader.onloadend = function () {
            popup.location.href = reader.result;
            popup = null;
        };
        reader.readAsDataURL(blob);
    }

};

// 保存作品 flag=false 自动保存不提示弹窗
export const saveFile = async (url, blob, filename = 'filename.sb3', flag = false) => {
    try {
        // 创建 FormData 对象并添加文件
        const formData = new FormData();
        formData.append('file', blob, filename);
        formData.append('userId', sessionStorage.getItem('userId') || '18712495260');

        // 发送 POST 请求
        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });

        // 检查响应是否成功
        if (!response.ok) {
            console.log('File uploaded fail');
            document.alert('文件上传失败！');
            return false;
        }

        // 解析 JSON 响应
        const data = await response.json();

        // 在这里，您可以根据需要处理响应数据
        if (flag) {
            // eslint-disable-next-line no-negated-condition
            if (!data.success) {
                // eslint-disable-next-line no-alert
                alert(data.msg);
            } else {
                // eslint-disable-next-line no-alert
                alert('保存成功！');
            }
        }

        // 返回响应数据以供进一步处理
        // return data;
    } catch (error) {
        // 处理错误情况
        console.error('Error during file upload:', error);
        // 可以选择抛出错误，以便在组件中捕获并处理
        throw error;
    }
};

// 提交作品
export const upFile = async (url, blob, filename = 'filename.sb3', imgBlob) => {
    try {
        const work = filename.split('.');
        const workTitle = work[0];
        console.log(workTitle);
        // 创建 FormData 对象并添加文件
        const formData = new FormData();
        formData.append('file', blob, filename);
        formData.append('classId', sessionStorage.getItem('classId') || '66389e4b1996e4087e88ba4c');
        formData.append('codeImg', imgBlob, 'asda.png');
        formData.append('workTitle', workTitle);
        formData.append('workType', 'SCRATCH');
        formData.append('studentId', sessionStorage.getItem('userId') || '18712495260');
        formData.append('studentName', sessionStorage.getItem('userName') || '小智慧');

        console.log(formData);
        // 发送 POST 请求
        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });

        // 检查响应是否成功
        if (!response.ok) {
            console.log('File uploaded fail');
            // eslint-disable-next-line no-alert
            alert('文件上传失败！');
            return false;
        }

        // 解析 JSON 响应
        const data = await response.json();

        // 在这里，您可以根据需要处理响应数据
        if (!data.success) {
            // eslint-disable-next-line no-alert
            alert(data.msg);
        } else {
            alert('作品提交成功！');
        }
        // 返回响应数据以供进一步处理
        // return data;
    } catch (error) {
        // 处理错误情况
        console.error('Error during file upload:', error);
        // 可以选择抛出错误，以便在组件中捕获并处理
        throw error;
    }
};
